import { render, staticRenderFns } from "./PatientNavigation.vue?vue&type=template&id=2f636d94"
import script from "./PatientNavigation.vue?vue&type=script&lang=js"
export * from "./PatientNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports